import React, { useEffect, useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import ConfirmCoverageArea from '../../molecules/confirm-coverage-area/confirm-coverage-area'
import SampleInfoCard from '../../molecules/sample-info-card/sample-info-card'
import ModalSampleInfo from '../../molecules/modal-sample-info/modal-sample-info'
import ModalLogin from '../../molecules/modal-login/modal-login'
import ModalAgeError from '../../molecules/modal-age-error/modal-age-error'
import userSession from '../../../shared/hooks/userSession'
import { getUserAge } from '../../../shared/utils/getUserAge'
import { siteUrl } from '../../../shared/utils/siteUrl'

const MODAL = {
  NONE: 0,
  SAMPLE_INFO: 1,
  LOGIN: 2,
  AGE_ERROR: 3,
}

const SampleRequest = () => {
  const {
    allContentfulVConfidentMuestraGratis: { nodes: content },
  } = useStaticQuery(graphql`
    {
      allContentfulVConfidentMuestraGratis(
          filter: {slug: {eq: "muestra-gratis/"}}
      ) {
        nodes {
          paisesDeRestriccion
          node_locale
          titulo
          metaTitulo
          metaDescripcion {
            metaDescripcion
          }
          bannerPrincipal {
            titulo
            banner {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
          tituloPrincipal
          tituloEnriquecido {
            raw
          }
          informacionPrincipal {
            raw
          }
          textoRegistroModalInicioSesion
          imagenModalInicioSesion {
            description
            gatsbyImageData(layout: CONSTRAINED)
          }
          enlaceRegistroModalInicioSesion
          tituloValidarCobertura
          mensajeSinCobertura
          informacionKit {
            raw
          }
          sellosKit {
            titulo
            imagenComponente {
              file {
                url
              }
            }
          }
          imagenKit {
            description
            gatsbyImageData(layout: FIXED)
          }
          textoTerminosYCondiciones {
            raw
          }
        }
      }
    }
  `)

  const contentCountry = content.filter(
    e =>
      e.node_locale === 'es-CO' &&
      !e.paisesDeRestriccion?.includes(process.env.LOCALE)
  )[0]

  const [modalOpen, setModalOpen] = useState(MODAL.NONE)

  const onRequestSampleModal = () => {
    const TOKEN_INFO = userSession.getToken()
    const USER_DATA = userSession.getUserInfo()

    if (TOKEN_INFO && USER_DATA) {
      const age = getUserAge(USER_DATA.birthdate)
      if (age >= 40) {
        window.location.href = siteUrl + '/muestra-gratis/confirmacion'
      } else {
        setModalOpen(MODAL.AGE_ERROR)
      }
    } else {
      setModalOpen(MODAL.LOGIN)
    }
  }

  useEffect( () => {
    if(localStorage.getItem('openModalLogin')) {
      localStorage.removeItem('openModalLogin')
      onRequestSampleModal()
    }
  }, [])

  return (
    <>
      <div className="f-sample-request">
        <ConfirmCoverageArea
          content={contentCountry}
          openModal={() => {
            onRequestSampleModal()
          }}
        />
        <SampleInfoCard
          content={contentCountry}
        />

        {modalOpen === MODAL.SAMPLE_INFO && (
          <ModalSampleInfo
            onClose={() => {
              setModalOpen(MODAL.NONE)
            }}
            onClickButton={onRequestSampleModal}
          />
        )}
        {modalOpen === MODAL.LOGIN && (
          <ModalLogin
            content={contentCountry}
            onSuccessAuth={user => {
              const userAge = getUserAge(user.birthdate)
              if (userAge >= 40) {
                window.location.href = siteUrl + '/muestra-gratis/confirmacion'
              } else {
                setModalOpen(MODAL.AGE_ERROR)
              }
            }}
            onClose={() => {
              setModalOpen(MODAL.NONE)
            }}
          />
        )}
        {modalOpen === MODAL.AGE_ERROR && (
          <ModalAgeError
            onClose={() => {
              setModalOpen(MODAL.NONE)
            }}
            openModal={() => {
              setModalOpen(MODAL.SAMPLE_INFO)
            }}
          />
        )}
      </div>
    </>
  )
}

export default SampleRequest
